interface DocSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
  accent?: 'green' | 'blue' | 'amber' | 'coral' | 'none';
}

const accentMap = {
  green: 'border-l-4 border-primary-500 pl-4',
  blue: 'border-l-4 border-[var(--slate)] pl-4',
  amber: 'border-l-4 border-electric-mustard-600 pl-4',
  coral: 'border-l-4 border-luminous-coral-700 pl-4',
  none: '',
};

export function DocSection({ title, description, children, className = '', accent = 'none' }: DocSectionProps) {
  return (
    <section className={`space-y-4 ${className}`}>
      <div className={accentMap[accent]}>
        <h2 className="text-lg font-semibold text-[var(--text-pri)] font-heading">{title}</h2>
        {description && <p className="text-sm text-[var(--text-ter)] mt-0.5">{description}</p>}
      </div>
      {children}
    </section>
  );
}
